import { render } from "./BookBookingConfirmation.vue?vue&type=template&id=cc56cf12"
import script from "./BookBookingConfirmation.vue?vue&type=script&lang=js"
export * from "./BookBookingConfirmation.vue?vue&type=script&lang=js"
script.render = render

export default script